import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row border-primary gx-0" }
const _hoisted_2 = { class: "col-12 border border-primary rounded-3" }
const _hoisted_3 = { class: "p-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-4" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Libre acceso - capacidad limitada."),
  /*#__PURE__*/_createElementVNode("strong", null, " Reserva es válida para 4 asistentes (1 titular + 3 acompañantes) ")
], -1)
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "col-12"
}

import { ActivitiesI } from '@/interfaces/ActivitiesI'
import TheReserveDay from '@/views/detail/TheReserveDay.vue'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'TheRecital',
  props: {
    actividad: null
  },
  setup(__props: any) {

const props = __props as {
  actividad: ActivitiesI
};



const turnosVip = ref<boolean | null>(null)

const verTurnosVip = (vip: boolean) => {
  turnosVip.value = vip
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            type: "submit",
            disabled: turnosVip.value === true,
            class: _normalizeClass(["btn btn-primary px-4 py-2 text-uppercase me-3", { 'select-btn': turnosVip.value === true }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (verTurnosVip(true)))
          }, " vip exclusivo ", 10, _hoisted_6),
          _createElementVNode("button", {
            type: "submit",
            disabled: turnosVip.value === false,
            class: _normalizeClass([{ 'select-btn': turnosVip.value === false }, "btn btn-primary px-4 py-2 text-uppercase me-3"]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (verTurnosVip(false)))
          }, " Campo general ", 10, _hoisted_7)
        ])
      ])
    ]),
    (turnosVip.value !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(TheReserveDay, {
            actividad: props.actividad,
            "con-acceso-vip": turnosVip.value
          }, null, 8, ["actividad", "con-acceso-vip"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})